import { useState } from "react";

const FeatureTabs = ({ shouldRenderIFrame }) => {
  const [selectedFeature, setSelectedFeature] = useState("capture");
  const videoIFrameStyle = {
    border: 0,
    borderRadius: "10px",
    width: "100%",
    aspectRatio: "16 / 9",
    boxShadow: "0px 15px 20px 0px rgba(5, 5, 5, 0.5)",
  };
  return (
    <div className="row">
      <div className="m-auto">
        <div className="works-header heading2 text-center">
          <span data-aos="fade-up" data-aos-duration="800">
            Knowledge Network
          </span>
          <h2 data-aos="fade-up" data-aos-duration="1000">
            Connect, Communicate, Collaborate
          </h2>
        </div>
      </div>
      <div className="space30"></div>
      <div className="col-lg-11 m-auto">
        <div
          className="tabs-button text-center"
          data-aos="fade-right"
          data-aos-duration="1000"
        >
          <div className="nav-work">
            <a
              href="javascript:void(0)"
              onClick={() => setSelectedFeature("capture")}
              className={selectedFeature === "capture" ? "active" : ""}
            >
              Capture
            </a>
            <a
              href="javascript:void(0)"
              onClick={() => setSelectedFeature("share")}
              className={selectedFeature === "share" ? "active" : ""}
            >
              Share
            </a>
            <a
              href="javascript:void(0)"
              onClick={() => setSelectedFeature("collaborate")}
              className={selectedFeature === "collaborate" ? "active" : ""}
            >
              Collaborate
            </a>
            <a
              href="javascript:void(0)"
              onClick={() => setSelectedFeature("discover")}
              className={selectedFeature === "discover" ? "active" : ""}
            >
              Discover
            </a>
            <a
              href="javascript:void(0)"
              onClick={() => setSelectedFeature("connect")}
              className={selectedFeature === "connect" ? "active" : ""}
            >
              Connect
            </a>
            <a
              href="javascript:void(0)"
              onClick={() => setSelectedFeature("organize")}
              className={selectedFeature === "organize" ? "active" : ""}
            >
              Organize
            </a>
          </div>
        </div>

        <div className="tabs-auhtor-area">
          <div className="tabContainer">
            <div
              className={`tab-content ${
                selectedFeature === "capture" ? "active" : ""
              }`}
            >
              <div className="tabs-img-content-area">
                <div className="row align-items-center">
                  <div className="col-lg-7">
                    <div className="tabs-auhtor-img reveal">
                      {shouldRenderIFrame && selectedFeature === "capture" && (
                        <iframe
                          className="img-fluid"
                          src="https://pixelmixer.pixelmixer.com/video/24184?channelShareCode=DZEJINMBWLJK&chromeless=true&galleryMode=false&playerOnly=true&backgroundColor=transparent"
                          style={videoIFrameStyle}
                          scrolling="no"
                          allowFullScreen="true"
                        ></iframe>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-5">
                    <div className="tabs-auhtor-content heading2">
                      <span>Capture</span>
                      <h2>Screen Recorder.</h2>
                      <p>
                        Record walkthroughs, decision rationale, and demos with
                        automatic transcription — context your team can search
                        later, not re-ask.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`tab-content ${
                selectedFeature === "share" ? "active" : ""
              }`}
            >
              <div className="tabs-img-content-area">
                <div className="row align-items-center">
                  <div className="col-lg-7">
                    <div className="tabs-auhtor-img reveal">
                      {shouldRenderIFrame && selectedFeature === "share" && (
                        <iframe
                          className="img-fluid"
                          src="https://pixelmixer.pixelmixer.com/video/24185?channelShareCode=DZEJINMBWLJK&chromeless=true&galleryMode=false&playerOnly=true&backgroundColor=transparent"
                          style={videoIFrameStyle}
                          scrolling="no"
                          allowFullScreen="true"
                        ></iframe>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-5">
                    <div className="tabs-auhtor-content heading2">
                      <span>Share</span>
                      <h2>Send it anywhere, securely.</h2>
                      <p>
                        Distribute a recording or summary via email, Slack, or
                        Teams. Secure by default, enterprise-controlled.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`tab-content ${
                selectedFeature === "collaborate" ? "active" : ""
              }`}
            >
              <div className="tabs-img-content-area">
                <div className="row align-items-center">
                  <div className="col-lg-7">
                    <div className="tabs-auhtor-img reveal">
                      {shouldRenderIFrame &&
                        selectedFeature === "collaborate" && (
                          <iframe
                            className="img-fluid"
                            src="https://pixelmixer.pixelmixer.com/video/23763?channelShareCode=DZEJINMBWLJK&chromeless=true&galleryMode=false&playerOnly=true&backgroundColor=transparent"
                            style={videoIFrameStyle}
                            scrolling="no"
                            allowFullScreen="true"
                          ></iframe>
                        )}
                    </div>
                  </div>
                  <div className="col-lg-5">
                    <div className="tabs-auhtor-content heading2">
                      <span>Collaborate</span>
                      <h2>Lives in your flow of work.</h2>
                      <p>
                        PixelMixer works inside Slack and Teams, so knowledge
                        shows up where decisions actually happen.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`tab-content ${
                selectedFeature === "discover" ? "active" : ""
              }`}
            >
              <div className="tabs-img-content-area">
                <div className="row align-items-center">
                  <div className="col-lg-7">
                    <div className="tabs-auhtor-img reveal">
                      {shouldRenderIFrame && selectedFeature === "discover" && (
                        <iframe
                          className="img-fluid"
                          src="https://pixelmixer.pixelmixer.com/video/23826?channelShareCode=DZEJINMBWLJK&chromeless=true&galleryMode=false&playerOnly=true&backgroundColor=transparent"
                          style={videoIFrameStyle}
                          scrolling="no"
                          allowFullScreen="true"
                        ></iframe>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-5">
                    <div className="tabs-auhtor-content heading2">
                      <span>Discover</span>
                      <h2>Ask the chatbot anything.</h2>
                      <p>
                        Need to know who owns the customer migration, or what
                        changed since last week? Ask in plain language and get
                        a sourced answer across your whole program.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`tab-content ${
                selectedFeature === "connect" ? "active" : ""
              }`}
            >
              <div className="tabs-img-content-area">
                <div className="row align-items-center">
                  <div className="col-lg-7">
                    <div className="tabs-auhtor-img reveal">
                      {shouldRenderIFrame && selectedFeature === "connect" && (
                        <iframe
                          className="img-fluid"
                          src="https://pixelmixer.pixelmixer.com/video/23764?channelShareCode=DZEJINMBWLJK&chromeless=true&galleryMode=false&playerOnly=true&backgroundColor=transparent"
                          style={videoIFrameStyle}
                          scrolling="no"
                          allowFullScreen="true"
                        ></iframe>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-5">
                    <div className="tabs-auhtor-content heading2">
                      <span>Connect</span>
                      <h2>Knowledge finds you.</h2>
                      <p>
                        Get told about the discussions, risks, and dependencies
                        that affect your work — before they become blockers.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`tab-content ${
                selectedFeature === "organize" ? "active" : ""
              }`}
            >
              <div className="tabs-img-content-area">
                <div className="row align-items-center">
                  <div className="col-lg-7">
                    <div className="tabs-auhtor-img reveal">
                      {shouldRenderIFrame && selectedFeature === "organize" && (
                        <iframe
                          className="img-fluid"
                          src="https://pixelmixer.pixelmixer.com/video/2915?shareCode=PRABIPULNXAE&chromeless=true&galleryMode=false&playerOnly=true&backgroundColor=transparent"
                          style={videoIFrameStyle}
                          scrolling="no"
                          allowFullScreen="true"
                        ></iframe>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-5">
                    <div className="tabs-auhtor-content heading2">
                      <span>Organize</span>
                      <h2>Channels, playlists, and program hubs.</h2>
                      <p>
                        A single, content-rich home for each program, event, or
                        team. Integrates with Confluence, Teams, and Slack.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeatureTabs;
